import ENUMS from '../enums';

import Dashboard from '../screens/dashboard';
import DashboardGuide from '../screens/dashboard/guide';
import Cafes from '../screens/cafes';
import EditWorkingHours from '../screens/cafes/List/edit/editWorkingHours';
import Users from '../screens/users';
import Payments from '../screens/payments/payments';
import FinancialTransactions from '../screens/financialTransactions';
import Settings from '../screens/settings';
import Comments from '../screens/comments';
import ChangePassword from '../screens/changePassword/changePassword';
import IntroducedCafes from '../screens/introducedCafes/introducedCafes';
import MyCafeInfoRouter from '../screens/cafes/MyCafeInfo/myCafeInfoRouter';
import Messages from '../screens/messages/rootIndex';
import MessageReceivers from '../screens/messages/messageReceivers/messageReceivers';
import InvoiceAdditions from '../screens/invoiceAdditions';
import DeletedInvoiceAdditions from '../screens/invoiceAdditions/DeletedList';
import CheckoutReport from '../screens/checkout/report/CheckoutReport';
import CompletedReservesReport from '../screens/reports/completedReservs/CompletedReservesReport';
import CheckoutsArchive from '../screens/checkout/archives/CheckoutsArchive';
// import InvoiceDeductions from '../screens/invoices/deductions/deductions';
// import DeductionsDeleteds from '../screens/invoices/deductions/deductionsDeleteds';
import MenuCategories from '../screens/menuCategories';
import MenuCategoriesDeleteds from '../screens/menuCategories/menuCategoriesDeleteds';
import MenuItems from '../screens/menuItems';
import MenuItemsDeleteds from '../screens/menuItems/menuItemsDeleteds';
import ReservationDays from '../screens/reserveTimes/Days';
import CreateReserveDay from '../screens/reserveTimes/Days/Create';
import ReservationHours from '../screens/reserveTimes/Hours';
import CreateReserveHour from '../screens/reserveTimes/Hours/Create';
// import AutoGenerateDaysAndHours from '../screens/reserveTimes/AutoGenerate';
import ReservesReport from '../screens/reserves/report';
import ReservesRequests from '../screens/reserves/requests';
import IncomingReserves from '../screens/reserves/incomings';
import SchematicReservation from '../screens/reserves/schematic';
import CafeDiscounts from '../screens/cafeDiscounts';
import CreateCafeDiscountRequest from '../screens/cafeDiscounts/Create/index';
import DiscountCodes from '../screens/discountCodes';
import AddOrEditDiscountCode from '../screens/discountCodes/addOrEditDiscountCode';
import DiscountCodeUsers from '../screens/discountCodes/discountCodesUsers/discountCodeUsers';
import Tickets from '../screens/tickets';
import TicketDetails from '../screens/tickets/ticketDetails';
import CafeDiscountRequestsManagement from '../screens/cafeDiscounts/rsee/cafeDiscountRequests';
import CafeDiscountRequestsArchive from '../screens/cafeDiscounts/rsee/cafeDiscountRequestsArchive';
import RseeDiscounts from '../screens/rseeDiscounts';
import CreateRseeDiscountRequest from '../screens/rseeDiscounts/Create';
import CafeEvents from '../screens/cafeEvents';
import AddOrEditCafeEvents from '../screens/cafeEvents/addOrEditCafeEvent';
import ArchivedCafeEvents from '../screens/cafeEvents/archives';
import RequestedCafeEvents from '../screens/cafeEvents/requesteds';
import ReserveCheckout from '../screens/checkout';
import AddOrEditReserveCheckout from '../screens/checkout/addOrEditReserveCheckout';
import ManageAds from '../screens/ads';
import ContractReports from '../screens/contractReports';
import SalesReport from '../screens/salesReport';
import PrintersList from '../screens/printers/printersList';
import ReservationTimingIndex from '../screens/reserves/timingTable/List';
import AddOrEditReservationTiming from '../screens/reserves/timingTable/AddOrEdit/addOrEditReservationTiming';
import TakeawayCAfesFinancialReport from '../screens/takeawayCafesFinancialReports';
import PackagesManagement from '../screens/packages/packagesManagement/packagesManagement';
import AddOrEditPackage from '../screens/packages/packagesManagement/AddOrEditPackage/AddNewPackage';
import GiftChairs from '../screens/packages/giftChairs/giftChairs';
import AddGiftChairs from '../screens/packages/giftChairs/AddGiftChairs/AddGiftChairs';
import PackagesReportIndex from '../screens/packages/packagesReport/packagesReportIndex';
import CitiesAndRegions from '../screens/citiesAndRegions';
import AddOrEditCity from '../screens/citiesAndRegions/addOrEditCity/AddOrEditCity';
import RegionsList from '../screens/citiesAndRegions/RegionsList';

export const routes = [
  {
    path: '/',
    component: Dashboard,
    exact: true,
  },
  {
    path: '/dashboard',
    component: Dashboard,
    exact: true,
  },
  {
    path: '/dashboard/guide',
    component: DashboardGuide,
    exact: true,
  },
  {
    path: '/cafes',
    component: Cafes,
    exact: false,
    permission: ENUMS.PERMISSIONS.values.VIEW_CAFES_LIST,
  },
  {
    path: '/cafes/editTimes',
    component: EditWorkingHours,
    exact: true,
  },
  {
    path: '/users',
    component: Users,
    exact: false,
    permission: ENUMS.PERMISSIONS.values.VIEW_USERS_LIST,
  },
  {
    path: '/payments/list',
    component: Payments,
    exact: true,
    permission: ENUMS.PERMISSIONS.values.VIEW_ONLINE_PAYMENTS_REPORT,
  },
  {
    path: '/financial-transactions/list',
    component: FinancialTransactions,
    exact: true,
    permission: ENUMS.PERMISSIONS.values.VIEW_FINANCIAL_TRANSACTIONS_REPORT,
  },
  {
    path: '/settings/list',
    component: Settings,
    exact: true,
    permission: ENUMS.PERMISSIONS.values.VIEW_SYSTEM_SETTINGS,
  },
  {
    path: '/reports/completed-reserves',
    component: CompletedReservesReport,
    exact: true,
    permission:
      ENUMS.PERMISSIONS.values.VIEW_REPORT_OF_COMPLETED_RESERVES_AND_NO_VISITS,
  },
  {
    path: '/comments',
    component: Comments,
    exact: true,
  },
  {
    path: '/change-password',
    component: ChangePassword,
    exact: true,
  },
  {
    path: '/introduced-cafes',
    component: IntroducedCafes,
    exact: true,
    permission: ENUMS.PERMISSIONS.values.VIEW_INTRODUCED_CAFES_LIST,
  },
  {
    path: '/my-cafe-info',
    component: MyCafeInfoRouter,
    exact: false,
    permission: ENUMS.PERMISSIONS.values.VIEW_MY_CAFE_INFO,
  },
  {
    path: '/messages',
    component: Messages,
    exact: false,
    permission: ENUMS.PERMISSIONS.values.VIEW_MESSAGES_LIST,
  },
  {
    path: '/message/receivers',
    component: MessageReceivers,
    exact: false,
    permission: ENUMS.PERMISSIONS.values.VIEW_MESSAGES_LIST,
  },
  {
    path: '/invoice-additions',
    component: InvoiceAdditions,
    exact: false,
    permission: ENUMS.PERMISSIONS.values.VIEW_CAFE_FACTOR_ADDITIONS_LIST,
  },
  // {
  //   path: '/invoice-deductions',
  //   component: InvoiceDeductions,
  //   exact: false,
  //   permission: ENUMS.PERMISSIONS.values.VIEW_CAFE_FACTOR_DEDUCTIONS_LIST
  // },
  {
    path: '/deleted-invoice-additions',
    component: DeletedInvoiceAdditions,
    exact: false,
    permission: ENUMS.PERMISSIONS.values.VIEW_CAFE_FACTOR_ADDITIONS_LIST,
  },
  // {
  //   path: '/invoice-deductions-deleteds',
  //   component: DeductionsDeleteds,
  //   exact: false,
  //   permission: ENUMS.PERMISSIONS.values.VIEW_CAFE_FACTOR_DEDUCTIONS_LIST
  // },
  {
    path: '/menu-categories',
    component: MenuCategories,
    exact: false,
    permission: ENUMS.PERMISSIONS.values.VIEW_MENU_CATEGORIES_LIST,
  },
  {
    path: '/menu-categories-deleteds',
    component: MenuCategoriesDeleteds,
    exact: false,
    permission: ENUMS.PERMISSIONS.values.VIEW_DELETED_MENU_CATEGORIES_LIST,
  },

  {
    path: '/menu-items',
    component: MenuItems,
    exact: false,
    permission: ENUMS.PERMISSIONS.values.VIEW_MENU_ITEMS_LIST,
  },
  {
    path: '/menu-items-deleteds',
    component: MenuItemsDeleteds,
    exact: false,
    permission: ENUMS.PERMISSIONS.values.VIEW_DELETED_MENU_ITEMS_LIST,
  },

  {
    path: '/reservation-days-management',
    component: ReservationDays,
    exact: true,
    permission: ENUMS.PERMISSIONS.values.VIEW_CAFE_DATES_LIST,
  },
  // {
  //   path: '/reservation-days/auto-generate',
  //   component: AutoGenerateDaysAndHours,
  //   exact: true,
  //   permission: ENUMS.PERMISSIONS.values.AUTO_GENERATE_RESERVE_DATES_AND_HOURS,
  // },
  {
    path: '/reservation-days/add-or-edit',
    component: CreateReserveDay,
    exact: true,
    permission: ENUMS.PERMISSIONS.values.ADD_NEW_CAFE_DATE,
  },
  {
    path: '/reservation-day/hours/:reservationDayId',
    component: ReservationHours,
    exact: true,
    permission: ENUMS.PERMISSIONS.values.VIEW_CAFE_TIME_SLICES_LIST,
  },
  // {
  //   path: '/reservation/hours/new',
  //   component: CreateReserveHour,
  //   exact: true,
  //   permission: ENUMS.PERMISSIONS.values.ADD_NEW_CAFE_TIME_SLICE
  // },
  {
    path: '/reservation/hours/edit',
    component: CreateReserveHour,
    exact: true,
    permission: ENUMS.PERMISSIONS.values.EDIT_CAFE_TIME_SLICE,
  },

  {
    path: '/reservations',
    component: ReservesReport,
    exact: true,
    permission: ENUMS.PERMISSIONS.values.VIEW_RESERVES_LIST,
  },
  {
    path: '/reservation-requests',
    component: ReservesRequests,
    exact: true,
    permission: ENUMS.PERMISSIONS.values.VIEW_RESERVES_LIST,
  },
  {
    path: '/incoming-reservations',
    component: IncomingReserves,
    exact: true,
    permission: ENUMS.PERMISSIONS.values.VIEW_RESERVES_LIST,
  },
  {
    path: '/schematic-reservations',
    component: SchematicReservation,
    exact: true,
    permission: ENUMS.PERMISSIONS.values.VIEW_RESERVES_SCHEMATIC_LIST,
  },
  {
    path: '/reservation-timing',
    component: ReservationTimingIndex,
    exact: true,
  },
  {
    path: '/reservation-timing/new-timing',
    component: AddOrEditReservationTiming,
    exact: true,
  },
  {
    path: '/reservation-timing/edit-timing',
    component: AddOrEditReservationTiming,
    exact: true,
  },
  {
    path: '/discount-codes',
    component: DiscountCodes,
    exact: true,
    permission: ENUMS.PERMISSIONS.values.VIEW_DISCOUNT_CODES_LIST,
  },
  {
    path: '/discount-codes/add-or-edit',
    component: AddOrEditDiscountCode,
    exact: true,
    permission: ENUMS.PERMISSIONS.values.ADD_NEW_DISCOUNT_CODE,
  },
  {
    path: '/discount-codes/users',
    component: DiscountCodeUsers,
    exact: true,
    permission: ENUMS.PERMISSIONS.values.ADD_NEW_DISCOUNT_CODE,
  },
  {
    path: '/cafe-discounts',
    component: CafeDiscounts,
    exact: true,
    permission: ENUMS.PERMISSIONS.values.VIEW_MY_CAFE_DISCOUNTS_LIST,
  },
  {
    path: '/cafe-discounts/create',
    component: CreateCafeDiscountRequest,
    exact: true,
    permission: ENUMS.PERMISSIONS.values.ADD_NEW_CAFE_DISCOUNT_REQUEST,
  },
  {
    path: '/tickets',
    component: Tickets,
    exact: true,
    permission: ENUMS.PERMISSIONS.values.VIEW_TICKETS_LIST,
  },
  {
    path: '/ticket/details',
    component: TicketDetails,
    exact: true,
    permission: ENUMS.PERMISSIONS.values.VIEW_TICKET_DETAILS,
  },
  {
    path: '/cafe-discounts/requests',
    component: CafeDiscountRequestsManagement,
    exact: true,
    permission: ENUMS.PERMISSIONS.values.VIEW_CAFE_DISCOUNTS_REQUESTED_LIST,
  },
  {
    path: '/cafe-discounts/archive',
    component: CafeDiscountRequestsArchive,
    exact: true,
    permission: ENUMS.PERMISSIONS.values.VIEW_CAFE_DISCOUNTS_ARCHIVED_LIST,
  },
  {
    path: '/rsee-discounts',
    component: RseeDiscounts,
    exact: true,
    permission: ENUMS.PERMISSIONS.values.VIEW_RSEE_DISCOUNTS_LIST,
  },
  {
    path: '/rsee-discounts/create',
    component: CreateRseeDiscountRequest,
    exact: true,
    permission: ENUMS.PERMISSIONS.values.ADD_NEW_RSEE_DISCOUNT,
  },
  {
    path: '/cafe-events',
    component: CafeEvents,
    exact: true,
    permission: ENUMS.PERMISSIONS.values.VIEW_MY_CAFE_EVENTS_LIST,
  },
  {
    path: '/cafe-events/add',
    component: AddOrEditCafeEvents,
    exact: true,
    permission: ENUMS.PERMISSIONS.values.ADD_NEW_CAFE_EVENT_REQUEST,
  },
  {
    path: '/cafe-events/edit',
    component: AddOrEditCafeEvents,
    exact: true,
    permission: ENUMS.PERMISSIONS.values.EDIT_CAFE_EVENT_REQUEST,
  },
  {
    path: '/cafe-events/archives',
    component: ArchivedCafeEvents,
    exact: true,
    permission: ENUMS.PERMISSIONS.values.VIEW_CAFE_EVENTS_ARCHIVED_LIST,
  },
  {
    path: '/cafe-events/requesteds',
    component: RequestedCafeEvents,
    exact: true,
    permission: ENUMS.PERMISSIONS.values.VIEW_CAFE_EVENTS_REQUESTED_LIST,
  },
  {
    path: '/reserve/checkout',
    component: ReserveCheckout,
    exact: true,
    permission: ENUMS.PERMISSIONS.values.VIEW_CHECKOUTS_WITH_CAFE_LIST,
  },
  {
    path: '/reserve/checkout/add-or-edit',
    component: AddOrEditReserveCheckout,
    exact: true,
    permission: ENUMS.PERMISSIONS.values.VIEW_CHECKOUTS_WITH_CAFE_LIST,
  },
  {
    path: '/checkout/report',
    component: CheckoutReport,
    exact: true,
    permission: ENUMS.PERMISSIONS.values.VIEW_RESERVES_READY_TO_CHECKOUT_LIST,
  },
  {
    path: '/checkout/archive',
    component: CheckoutsArchive,
    exact: true,
    permission: ENUMS.PERMISSIONS.values.VIEW_CHECKOUTS_WITH_CAFE_LIST,
  },
  {
    path: '/ads',
    component: ManageAds,
    exact: false,
    permission: ENUMS.PERMISSIONS.values.VIEW_ADS_LIST,
  },
  {
    path: '/cafes-contract',
    component: ContractReports,
    exact: false,
    permission: ENUMS.PERMISSIONS.values.VIEW_CAFE_CONTRACTS_LIST,
  },
  {
    path: '/sales/list',
    component: SalesReport,
    exact: true,
    permission: ENUMS.PERMISSIONS.values.SALES_REPORT,
  },
  {
    path: '/packages/management',
    component: PackagesManagement,
    exact: true,
    // permission: 
  },
  {
    path: '/packages/management/add-or-edit-package',
    component: AddOrEditPackage,
    exact: true,
    // permission: 
  },
  {
    path: '/packages/report',
    component: PackagesReportIndex,
    exact: true,
    // permission:
  },
  {
    path: '/packages/gift-chairs',
    component: GiftChairs,
    exact: true,
    // permission: 
  },
  {
    path: '/packages/gift-chairs/add',
    component: AddGiftChairs,
    exact: true,
    // permission: 
  },
  // {
  //   path: '/printer',
  //   component: PrintersList,
  //   exact: true,
  //   permission: ENUMS.PERMISSIONS.values.VIEW_PRINTERS_LIST,
  // },
  {
    path: '/takeaway-cafes-financial-report',
    component: TakeawayCAfesFinancialReport,
    exact: true,
    // permission: ,
  },
  {
    path: '/cities-and-regions',
    component: CitiesAndRegions,
    exact: true,
    permission: ENUMS.PERMISSIONS.values.VIEW_CITIES_LIST,
  },
  {
    path: '/add-or-edit-city',
    component: AddOrEditCity,
    exact: true,
    permission: ENUMS.PERMISSIONS.values.ADD_NEW_CITY && ENUMS.PERMISSIONS.values.EDIT_CITY,
  },
  {
    path: '/regions-of-city',
    component: RegionsList,
    exact: true,
    permission: ENUMS.PERMISSIONS.values.VIEW_REGIONS_LIST,
  },
];
